///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useRef, useEffect } from "react";

export const OutlinedInput = ({
  error,
  validationMessage,
  value,
  label,
  className,
  unit,
  isUnitPositionLeft,
  style,
  isMulti = false,
  children,
  dynamicHeight,
  required = false,
  helpertext,
  ...rest
}) => {
  let element = useRef();
  useEffect(() => {
    if (isMulti && dynamicHeight) {
      element.style.height = "";
      element.style.height = element.scrollHeight + 2 + "px";
    }
  });
  return (
    <div
      className="outlined-input"
      style={{ height: isMulti ? undefined : 50 }}
    >
      {isMulti ? (
        <textarea
          className={`control scroll ${value === 0 || value ? "filled" : ""} ${
            error ? "error" : ""
          } ${className || ""}`}
          value={value}
          style={{ resize: "none", ...style }}
          ref={e => (element = e)}
          {...rest}
        />
      ) : (
        <input
          className={`control ${value === 0 || value ? "filled" : ""} ${
            error ? "error" : ""
          } ${className || ""}`}
          type="text"
          value={value}
          style={{
            paddingLeft: isUnitPositionLeft ? 24 : undefined,
            height: 32,
            ...style
          }}
          autoComplete="off"
          {...rest}
        />
      )}
      <label
        disabled={rest.disabled}
        className={
          "shrinkable-label" +
          (error ? " error" : "") +
          (required ? " required" : "")
        }
      >
        {label}
      </label>
      {unit && (
        <span className={`input-unit ${isUnitPositionLeft ? "left" : "right"}`}>
          {unit}
        </span>
      )}
      {error && (
        <label className="validation-message">{validationMessage}</label>
      )}
      {helpertext && (
        <label
          className={`helper-message ${error ? "validation-message" : ""}`}
        >
          {helpertext}
        </label>
      )}
      {children}
    </div>
  );
};

export default OutlinedInput;
